import { StepType } from 'V2/Apply';

// Vite transforms import.meta.glob at build time into a map of lazy chunk
// loaders — one per step folder. This enables proper code-splitting that
// Webpack's dynamic `import()` used to handle automatically.
const stepModules = import.meta.glob<{ default: React.FC<StepType> }>(
  '../../Steps/*/index.{ts,tsx}'
);

/** Look up a step's lazy loader by component name. */
export const loadStep = (
  componentName: string
): (() => Promise<{ default: React.FC<StepType> }>) | undefined => {
  const tsKey = `../../Steps/${componentName}/index.ts`;
  const tsxKey = `../../Steps/${componentName}/index.tsx`;
  return stepModules[tsKey] || stepModules[tsxKey];
};
